import React, { useState } from 'react'
import PropTypes from 'prop-types'
import formatCurrency from 'utils/formatCurrency'
import { createTransfer } from 'actions/transfers'
import { InfoOutlined } from '@material-ui/icons'
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography, Divider, makeStyles, Link, Box } from '@material-ui/core'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import { useDispatch } from 'react-redux'
import StripeConnect from 'components/stripe/StripeConnect'
import { setNotification } from 'actions/status'

const sixpenceFeeRate = 0.049

const useStyles = makeStyles(() => ({
  amount: {
    float: 'right'
  }
}))

export default function ConfirmDialog({ handleClose, open, amount, jarId }) {
  const [isProcessing, setIsProcessing] = useState(false)
  const classes = useStyles()
  const fundraiserAccount = useCurrentUserProp('fundraiserAccount')
  const dispatch = useDispatch()
  const feeAmount = amount * sixpenceFeeRate
  async function handleConfirm() {
    try {
      setIsProcessing(true)
      await dispatch(createTransfer(jarId))
      dispatch(setNotification(
        'success', 'Your payout is in process. Please allow 24-48 hours for completion.', { duration: null }
      ))
    } catch {
      dispatch(setNotification(
        'error', 'Your payout encountered an error. Contact team@sixpenceapp.com to resolve.', { duration: null }
      ))
    } finally {
      setIsProcessing(false)
      handleClose()
    }
  }

  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
      <DialogTitle>Confirm Payout?</DialogTitle>
      <DialogContent>
        {fundraiserAccount ? (
          // TODO: JOSH - update both of these info links when Chris has hyperlinks
          <Typography variant='body2'>
            Estimated Transfer Duration: 24 hours <sup><Link target='_blank' rel='noopener noreferrer' href='https://sixpenceapp.com/faq/' variant='body2'>More Details<InfoOutlined fontSize='inherit' /></Link></sup>
          </Typography>
        ) : (
          <React.Fragment>
            <Typography variant='subtitle2'>
              Connect the bank account you’ll utilize for payouts through Stripe here.
            </Typography>
            <StripeConnect payoutJar={jarId} />
          </React.Fragment>
        )}
        <Box pt={3}>
          <Typography variant='h6'>
            Available Balance:
            <span className={classes.amount}>{formatCurrency(amount)}</span>
          </Typography>
          <Typography variant='h6'>
            Fees: <sup><Link target='_blank' rel='noopener noreferrer' href='https://sixpenceapp.com/faq/' variant='body2'>More Details<InfoOutlined fontSize='inherit' /></Link></sup>
            <span className={classes.amount}>{formatCurrency(feeAmount)}</span>
          </Typography>
          <Divider />
          <Typography color='secondary' variant='h6'>
            Total Payout:
            <span className={classes.amount}>{formatCurrency(amount - feeAmount)}</span>
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant='text' color='secondary'>
          cancel
        </Button>
        <Button disabled={!fundraiserAccount || isProcessing} onClick={handleConfirm} variant='contained' color='secondary'>
          confirm
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ConfirmDialog.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  amount: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired
  ]),
  jarId: PropTypes.string.isRequired
}
